export default {
  attendScoreTasks: '/honour/client/attendScoreTasks'
}
